<script setup lang="ts">
import LeftSideBar from "./components/LeftSideBar.vue";
import BuyVIPDialogues from "@/components/Dialogues/BuyVIPDialogues.vue";
import UserServiceDialogue from "@/components/Dialogues/UserServiceDialogue.vue";
import LogoutDialogues from "@/components/Dialogues/LogoutDialogues.vue";
import ChatBase from "@/components/Dialogues/Chat/ChatBase.vue";
import LoginDialogue from "@/components/Dialogues/LoginDialogue.vue";
import EditChatTitleDialogue from "@/components/Dialogues/EditChatTitleDialogue.vue";
import DeleteChatHistoryDialogue from "@/components/Dialogues/DeleteChatHistoryDialogue.vue";

import { isExpand } from "@/views/Home/useData/useHomePage";
import { ref, watch, computed } from "vue";
import { getDeviceWidth } from "@/utils/device";
import { isCompactMode } from "@/data/pubilc";
import LeftSideBarDrawer from "@/views/Home/components/LeftSideBarDrawer.vue";
import CustomPopup from "@/components/custom-popup/customPopup.vue";
const deviceWidth = getDeviceWidth();

watch(deviceWidth, () => {
  const newWidth = deviceWidth.value;
  isCompactMode.value = newWidth <= 680;
  if (newWidth > 1000) {
    isExpand.value = true;
  } else if (newWidth <= 1000) {
    isExpand.value = false;
  }
});
</script>

<template>
  <el-container class="page-base">
    <el-main class="p0">
      <div class="content">
        <LeftSideBar v-if="!isCompactMode" />
        <ChatBase />
      </div>
    </el-main>
    <BuyVIPDialogues />
    <UserServiceDialogue />
    <LogoutDialogues />
    <LoginDialogue />
    <EditChatTitleDialogue />
    <DeleteChatHistoryDialogue />
    <LeftSideBarDrawer v-if="isCompactMode" />
    <CustomPopup />
  </el-container>
</template>

<style lang="scss" scoped>
.page-base {
  padding: 0;
  width: 100dvw;
  height: 100dvh;
}

.p0 {
  padding: 0;
}

.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}
</style>
